function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff8acb;}.cls-1,.cls-2{opacity:0.5;}.cls-2{fill:#35fff0;}.cls-3{fill:#2aff72;}.cls-4,.cls-5{fill:#fcee00;}.cls-5,.cls-6{stroke:#fcee00;stroke-width:2px;}.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-5,.cls-6{stroke-miterlimit:10;}.cls-29,.cls-31,.cls-6{fill:none;}.cls-7{fill:#6affb9;}.cls-8{fill:#70ff3f;}.cls-9{fill:#eadfff;}.cls-10{fill:#35a1ff;}.cls-11{fill:#ff7ff6;}.cls-12{fill:#4affa0;}.cls-13{fill:#000f8a;}.cls-14{fill:#ff722a;}.cls-15{fill:#8afffd;}.cls-16{fill:#5fffdd;}.cls-17{fill:#f0ff6a;}.cls-18{fill:#f40aff;}.cls-19{fill:#df0038;}.cls-20{fill:#ffe5aa;}.cls-21{fill:#fbff0a;}.cls-22{fill:#ff15ee;}.cls-23{fill:#ba9fff;}.cls-24{fill:#00fbff;}.cls-25{fill:#9fc5ff;}.cls-26{fill:#00c938;}.cls-27{fill:#a6ff35;}.cls-28{fill:#74ffb3;}.cls-28,.cls-29{stroke:#74ffb3;}.cls-29,.cls-31,.cls-33{stroke-width:5px;}.cls-30{fill:#ff1fa3;}.cls-30,.cls-31{stroke:#ff1fa3;}.cls-32,.cls-33{fill:#ff8a8d;stroke:#ff8a8d;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "hero");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1133.5,261C1244.41,246.64,777,512,610,422,353.54,283.79,20.87,356.85,78.5,261,319-139,307.81,238.24,597,203,995,154.5,755,310,1133.5,261Z",
  transform: "translate(-71.92 -62)"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-2",
  cx: 933.58,
  cy: 65.5,
  r: 65.5
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 225,
  y: 223,
  width: 161,
  height: 107,
  transform: "matrix(0.95, -0.3, 0.3, 0.95, -140.47, 41.69)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M227.11,259.49a2.5,2.5,0,0,1-.74-4.89,2.67,2.67,0,0,1,.75-.11,2.5,2.5,0,0,1,2.21,3.66,2.44,2.44,0,0,1-1.47,1.22A2.36,2.36,0,0,1,227.11,259.49Z",
  transform: "translate(-71.92 -62)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M227.12,255.49h0a1.5,1.5,0,0,1,.44,2.93,1.41,1.41,0,0,1-.45.07,1.49,1.49,0,0,1-1.32-2.2,1.46,1.46,0,0,1,.88-.73,1.33,1.33,0,0,1,.45-.07m0-2a3.5,3.5,0,1,0,1,6.84,3.5,3.5,0,0,0-1-6.84Z",
  transform: "translate(-71.92 -62)"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-5",
  cx: 226.78,
  cy: 172.62,
  r: 3.5
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-5",
  cx: 301.68,
  cy: 192.7,
  r: 4
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-5",
  cx: 314.5,
  cy: 233.74,
  r: 4
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-5",
  cx: 215.24,
  cy: 264.76,
  r: 4
});

var _ref13 = /*#__PURE__*/React.createElement("polyline", {
  className: "cls-6",
  points: "155.2 194.99 226.78 172.62 249.45 245.16 243.87 255.81 230.33 260.04 214.76 264.91 189.56 184.25"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M385.79,295.42l-69.67,21.77Z",
  transform: "translate(-71.92 -62)"
});

var _ref15 = /*#__PURE__*/React.createElement("polyline", {
  className: "cls-6",
  points: "249.45 245.16 299.08 229.66 307.62 213.37 301.35 193.33 239.31 212.71"
});

var _ref16 = /*#__PURE__*/React.createElement("polyline", {
  className: "cls-6",
  points: "246.47 235.62 259.83 231.44 268.03 215.78 264.6 204.81 252.08 164.72 226.78 172.62"
});

var _ref17 = /*#__PURE__*/React.createElement("polyline", {
  className: "cls-6",
  points: "301.35 193.33 296.28 177.1 293.3 167.56 274.51 157.71 251.6 164.87"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M226.16,257.29",
  transform: "translate(-71.92 -62)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M260.25,246.23",
  transform: "translate(-71.92 -62)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M293.45,294.93l8.35,26.73Z",
  transform: "translate(-71.92 -62)"
});

var _ref21 = /*#__PURE__*/React.createElement("polyline", {
  className: "cls-6",
  points: "221.53 232.93 220.66 230.16 200.35 219.52"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M286.83,327.38",
  transform: "translate(-71.92 -62)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M286.53,326.43,255,336.27l-6.89-3.61-7.61-24.34s8.95-2.64,18-5.39c9.26-2.81,18.66-5.75,18.86-6.13l37.1-11.59,62-19.38",
  transform: "translate(-71.92 -62)"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 139,
  y: 124,
  width: 110,
  height: 164,
  transform: "matrix(0.26, -0.96, 0.96, 0.26, -127.64, 277.07)"
});

var _ref25 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 34.3,
  y1: 177.1,
  x2: 48.75,
  y2: 124.04
});

var _ref26 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 39.36,
  y1: 178.48,
  x2: 52,
  y2: 132.05
});

var _ref27 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 44.92,
  y1: 179.99,
  x2: 56.36,
  y2: 137.98
});

var _ref28 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 49.74,
  y1: 181.31,
  x2: 64.19,
  y2: 128.24
});

var _ref29 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 54.8,
  y1: 182.68,
  x2: 69.25,
  y2: 129.62
});

var _ref30 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 60.36,
  y1: 184.2,
  x2: 73,
  y2: 137.76
});

var _ref31 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 65.18,
  y1: 185.51,
  x2: 77.82,
  y2: 139.08
});

var _ref32 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 70.24,
  y1: 186.89,
  x2: 83.25,
  y2: 138.18
});

var _ref33 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 75.79,
  y1: 188.4,
  x2: 87.23,
  y2: 146.39
});

var _ref34 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 80.62,
  y1: 189.71,
  x2: 94.46,
  y2: 138.86
});

var _ref35 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 85.67,
  y1: 191.09,
  x2: 100.12,
  y2: 138.02
});

var _ref36 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 91.23,
  y1: 192.6,
  x2: 103.87,
  y2: 146.17
});

var _ref37 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 97.02,
  y1: 194.18,
  x2: 111.47,
  y2: 141.11
});

var _ref38 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 102.08,
  y1: 195.56,
  x2: 114.72,
  y2: 149.12
});

var _ref39 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 107.64,
  y1: 197.07,
  x2: 119.07,
  y2: 155.06
});

var _ref40 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 112.46,
  y1: 198.38,
  x2: 124.5,
  y2: 154.16
});

var _ref41 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 117.51,
  y1: 199.76,
  x2: 129.55,
  y2: 155.53
});

var _ref42 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 123.07,
  y1: 201.27,
  x2: 135.72,
  y2: 154.84
});

var _ref43 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 127.9,
  y1: 202.58,
  x2: 140.54,
  y2: 156.15
});

var _ref44 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 132.95,
  y1: 203.96,
  x2: 147.17,
  y2: 150.83
});

var _ref45 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 138.51,
  y1: 205.47,
  x2: 151.76,
  y2: 156.83
});

var _ref46 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 143.34,
  y1: 206.79,
  x2: 157.18,
  y2: 155.93
});

var _ref47 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 148.39,
  y1: 208.16,
  x2: 161.63,
  y2: 159.52
});

var _ref48 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 153.95,
  y1: 209.68,
  x2: 167.19,
  y2: 161.03
});

var _ref49 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 159.97,
  y1: 211.32,
  x2: 174.19,
  y2: 158.18
});

var _ref50 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 165.53,
  y1: 212.83,
  x2: 178.77,
  y2: 164.18
});

var _ref51 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 170.35,
  y1: 214.14,
  x2: 184.2,
  y2: 163.29
});

var _ref52 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 175.41,
  y1: 215.52,
  x2: 188.65,
  y2: 166.87
});

var _ref53 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 180.97,
  y1: 217.03,
  x2: 194.21,
  y2: 168.39
});

var _ref54 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 390,
  y: 316,
  width: 164,
  height: 110,
  transform: "translate(-200.16 320.52) rotate(-39.27)"
});

var _ref55 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 424.11,
  y1: 218.32,
  x2: 458.92,
  y2: 260.9
});

var _ref56 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 420.05,
  y1: 221.63,
  x2: 450.51,
  y2: 258.89
});

var _ref57 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 415.59,
  y1: 225.28,
  x2: 443.15,
  y2: 258.99
});

var _ref58 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 411.72,
  y1: 228.44,
  x2: 446.53,
  y2: 271.02
});

var _ref59 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 407.67,
  y1: 231.76,
  x2: 442.48,
  y2: 274.34
});

var _ref60 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 403.21,
  y1: 235.4,
  x2: 433.67,
  y2: 272.66
});

var _ref61 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 399.34,
  y1: 238.57,
  x2: 429.8,
  y2: 275.83
});

var _ref62 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 395.28,
  y1: 241.89,
  x2: 427.38,
  y2: 280.77
});

var _ref63 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 390.82,
  y1: 245.53,
  x2: 418.38,
  y2: 279.24
});

var _ref64 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 386.95,
  y1: 248.7,
  x2: 420.31,
  y2: 289.5
});

var _ref65 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 382.89,
  y1: 252.01,
  x2: 417.7,
  y2: 294.59
});

var _ref66 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 378.43,
  y1: 255.66,
  x2: 408.89,
  y2: 292.92
});

var _ref67 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 373.79,
  y1: 259.46,
  x2: 408.6,
  y2: 302.04
});

var _ref68 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 369.73,
  y1: 262.77,
  x2: 400.19,
  y2: 300.03
});

var _ref69 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 365.27,
  y1: 266.42,
  x2: 392.83,
  y2: 300.13
});

var _ref70 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 361.4,
  y1: 269.58,
  x2: 390.41,
  y2: 305.07
});

var _ref71 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 357.34,
  y1: 272.9,
  x2: 386.35,
  y2: 308.38
});

var _ref72 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 352.88,
  y1: 276.55,
  x2: 383.34,
  y2: 313.8
});

var _ref73 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 349.01,
  y1: 279.71,
  x2: 379.47,
  y2: 316.97
});

var _ref74 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 344.96,
  y1: 283.03,
  x2: 379.95,
  y2: 325.46
});

var _ref75 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 340.5,
  y1: 286.67,
  x2: 372.41,
  y2: 325.71
});

var _ref76 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 336.63,
  y1: 289.84,
  x2: 369.99,
  y2: 330.64
});

var _ref77 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 332.57,
  y1: 293.15,
  x2: 364.48,
  y2: 332.19
});

var _ref78 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 328.11,
  y1: 296.8,
  x2: 360.02,
  y2: 335.83
});

var _ref79 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 323.28,
  y1: 300.75,
  x2: 358.28,
  y2: 343.18
});

var _ref80 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 318.82,
  y1: 304.4,
  x2: 350.73,
  y2: 343.43
});

var _ref81 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 314.95,
  y1: 307.56,
  x2: 348.31,
  y2: 348.37
});

var _ref82 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 310.89,
  y1: 310.88,
  x2: 342.8,
  y2: 349.91
});

var _ref83 = /*#__PURE__*/React.createElement("line", {
  className: "cls-6",
  x1: 306.43,
  y1: 314.52,
  x2: 338.34,
  y2: 353.56
});

var _ref84 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-9",
  x: 1048.54,
  y: 218.6,
  width: 135,
  height: 243,
  rx: 19.53,
  transform: "translate(206.76 -534.32) rotate(27.19)"
});

var _ref85 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 1143.66,
  y: 246.55,
  width: 27,
  height: 27,
  rx: 4.48,
  transform: "translate(174.72 -561.95) rotate(27.19)"
});

var _ref86 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: 1175.68,
  y: 262.99,
  width: 27,
  height: 27,
  rx: 4.48,
  transform: "translate(185.77 -574.76) rotate(27.19)"
});

var _ref87 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-12",
  x: 1111.64,
  y: 230.1,
  width: 27,
  height: 27,
  rx: 4.48,
  transform: "translate(163.67 -549.14) rotate(27.19)"
});

var _ref88 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-13",
  x: 1127.21,
  y: 278.57,
  width: 27,
  height: 27,
  rx: 4.48,
  transform: "translate(187.54 -550.9) rotate(27.19)"
});

var _ref89 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 1159.23,
  y: 295.02,
  width: 27,
  height: 27,
  rx: 4.48,
  transform: "translate(198.59 -563.71) rotate(27.19)"
});

var _ref90 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-15",
  x: 1095.19,
  y: 262.12,
  width: 27,
  height: 27,
  rx: 4.48,
  transform: "translate(176.48 -538.08) rotate(27.19)"
});

var _ref91 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-16",
  x: 1110.76,
  y: 310.59,
  width: 27,
  height: 27,
  rx: 4.48,
  transform: "translate(200.35 -539.85) rotate(27.19)"
});

var _ref92 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-17",
  x: 1142.79,
  y: 327.04,
  width: 27,
  height: 27,
  rx: 4.48,
  transform: "translate(211.4 -552.66) rotate(27.19)"
});

var _ref93 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-18",
  x: 1078.74,
  y: 294.14,
  width: 27,
  height: 27,
  rx: 4.48,
  transform: "translate(189.3 -527.03) rotate(27.19)"
});

var _ref94 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-19",
  x: 1094.32,
  y: 342.62,
  width: 27,
  height: 27,
  rx: 4.48,
  transform: "translate(213.16 -528.79) rotate(27.19)"
});

var _ref95 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-20",
  x: 1126.34,
  y: 359.06,
  width: 27,
  height: 27,
  rx: 4.48,
  transform: "translate(224.22 -541.61) rotate(27.19)"
});

var _ref96 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-21",
  x: 1062.29,
  y: 326.17,
  width: 27,
  height: 27,
  rx: 4.48,
  transform: "translate(202.11 -515.98) rotate(27.19)"
});

var _ref97 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-22",
  x: 1077.87,
  y: 374.64,
  width: 27,
  height: 27,
  rx: 4.48,
  transform: "translate(225.98 -517.74) rotate(27.19)"
});

var _ref98 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-23",
  x: 1109.89,
  y: 391.09,
  width: 27,
  height: 27,
  rx: 4.48,
  transform: "translate(237.03 -530.56) rotate(27.19)"
});

var _ref99 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-24",
  x: 1045.85,
  y: 358.19,
  width: 27,
  height: 27,
  rx: 4.48,
  transform: "translate(214.92 -504.93) rotate(27.19)"
});

var _ref100 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-25",
  x: 1061.42,
  y: 406.66,
  width: 27,
  height: 27,
  rx: 4.48,
  transform: "translate(238.79 -506.69) rotate(27.19)"
});

var _ref101 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-26",
  x: 1093.44,
  y: 423.11,
  width: 27,
  height: 27,
  rx: 4.48,
  transform: "translate(249.84 -519.5) rotate(27.19)"
});

var _ref102 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-27",
  x: 1029.4,
  y: 390.21,
  width: 27,
  height: 27,
  rx: 4.48,
  transform: "translate(227.74 -493.88) rotate(27.19)"
});

var _ref103 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-28",
  cx: 813.58,
  cy: 148.5,
  r: 13.5
});

var _ref104 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-28",
  cx: 867.58,
  cy: 135.5,
  r: 13.5
});

var _ref105 = /*#__PURE__*/React.createElement("polyline", {
  className: "cls-29",
  points: "824.58 147 824.58 74.14 878.08 52 878.08 138.95"
});

var _ref106 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-30",
  cx: 906.94,
  cy: 180.33,
  r: 13.5
});

var _ref107 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-30",
  cx: 962.75,
  cy: 175.54,
  r: 13.5
});

var _ref108 = /*#__PURE__*/React.createElement("polyline", {
  className: "cls-31",
  points: "918.04 180.71 930.38 108.91 986.86 96.15 972.13 181.84"
});

var _ref109 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-32",
  cx: 752.8,
  cy: 188.56,
  r: 13.5
});

var _ref110 = /*#__PURE__*/React.createElement("line", {
  className: "cls-33",
  x1: 763.62,
  y1: 186.07,
  x2: 789.4,
  y2: 254.21
});

var SvgHero = function SvgHero(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1152.91 410.26",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHero, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hero.a2bbc8ad.svg";
export { ForwardRef as ReactComponent };